export default __webpack_public_path__ + "static/media/smiling-woman-and-wellness-coach-2021-08-26-15-45-37-utc.a2311c0c.jpg";